'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortSellers = exports.sortItems = exports.sortCatalogs = exports.getPriceFromCard = exports.filterSellerSearch = exports.filterItemSearch = exports.filterCatalogSearch = exports.filterEmptySellers = exports.filterEmptyItems = exports.filterEmptyCatalogs = exports.sellerSearchFilter = exports.itemSearchFilter = exports.catalogSearchFilter = exports.filterSellers = exports.filterItems = exports.filterCatalogs = exports.filterCatalogsByReg = exports.catalogApprovedFilter = exports.catalogDoneFilter = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flow = require('lodash/fp/flow');

var _flow2 = _interopRequireDefault(_flow);

var _catalogRegistration = require('./catalogRegistration');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _pagination = require('../../utils/pagination');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tab Filters
var catalogDoneFilter = exports.catalogDoneFilter = function catalogDoneFilter(wrapper, tab) {
    if (tab === 'ended') {
        return wrapper.catalog.catalogStatus === 'done';
    }
    return wrapper.catalog.catalogStatus !== 'done';
};

var catalogApprovedFilter = exports.catalogApprovedFilter = function catalogApprovedFilter(state, wrapper, tab) {
    var _getUserCatalogRegist = (0, _catalogRegistration.getUserCatalogRegistration)(state, wrapper.catalog.catalogId),
        approved = _getUserCatalogRegist.approved,
        pending = _getUserCatalogRegist.pending;

    if (tab === 'approved') {
        return approved;
    } else if (tab === 'pending') {
        return pending;
    }
    return false;
};

// Filter Functions
var filterCatalogsByReg = exports.filterCatalogsByReg = function filterCatalogsByReg(state, all) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        count = _ref.count,
        page = _ref.page,
        sort = _ref.sort,
        tab = _ref.tab,
        terms = _ref.terms;

    var loaded = filterEmptyCatalogs(all);
    var tabbed = tab ? loaded.filter(function (x) {
        return catalogApprovedFilter(state, x, tab);
    }) : loaded;
    var sorted = sortCatalogs(tabbed, sort);
    var filtered = filterCatalogSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterCatalogs = exports.filterCatalogs = function filterCatalogs(all) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref2.count,
        page = _ref2.page,
        sort = _ref2.sort,
        tab = _ref2.tab,
        terms = _ref2.terms;

    var loaded = filterEmptyCatalogs(all);
    var tabbed = tab ? loaded.filter(function (x) {
        return catalogDoneFilter(x, tab);
    }) : loaded;
    var sorted = sortCatalogs(tabbed, sort);
    var filtered = filterCatalogSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterItems = exports.filterItems = function filterItems(all) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref3.count,
        page = _ref3.page,
        sort = _ref3.sort,
        tab = _ref3.tab,
        terms = _ref3.terms;

    var loaded = filterEmptyItems(all);
    var tabbed = tab ? loaded.filter(function (itemWrapper) {
        return catalogDoneFilter(itemWrapper, tab);
    }) : loaded;
    var sorted = sortItems(tabbed, sort);
    var filtered = filterItemSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        tabbedCount: tabbed.length || 0,
        totalCount: all.length || 0
    };
};

var filterSellers = exports.filterSellers = function filterSellers(all) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        count = _ref4.count,
        page = _ref4.page,
        sort = _ref4.sort,
        terms = _ref4.terms;

    var loaded = filterEmptySellers(all);
    var sorted = sortSellers(loaded, sort);
    var filtered = filterSellerSearch(sorted, terms);

    return {
        filteredCount: filtered.length || 0,
        items: (0, _pagination.pageSlicer)(filtered, count, page) || [],
        loadedItemsCount: loaded.length,
        totalCount: all.length || 0
    };
};

// Search Filters
var catalogSearchFilter = exports.catalogSearchFilter = function catalogSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.catalog) return false;
        var _wrapper$catalog$titl = wrapper.catalog.title,
            title = _wrapper$catalog$titl === undefined ? '' : _wrapper$catalog$titl;

        return ('' + title).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var itemSearchFilter = exports.itemSearchFilter = function itemSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.item) return false;
        var _wrapper$item = wrapper.item,
            _wrapper$item$descrip = _wrapper$item.description,
            description = _wrapper$item$descrip === undefined ? '' : _wrapper$item$descrip,
            _wrapper$item$lotNumb = _wrapper$item.lotNumber,
            lotNumber = _wrapper$item$lotNumb === undefined ? '' : _wrapper$item$lotNumb,
            _wrapper$item$title = _wrapper$item.title,
            title = _wrapper$item$title === undefined ? '' : _wrapper$item$title;

        return (description + ' ' + lotNumber + ' ' + title).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var sellerSearchFilter = exports.sellerSearchFilter = function sellerSearchFilter(wrapper, searchString) {
    var searchTokens = searchString.toLowerCase().trim().split(/\s/);
    var matchingTokens = searchTokens.filter(function (token) {
        if (!wrapper || !wrapper.seller) return false;
        var _wrapper$seller$name = wrapper.seller.name,
            name = _wrapper$seller$name === undefined ? '' : _wrapper$seller$name;

        return ('' + name).toLowerCase().includes(token);
    });
    var doesMatch = matchingTokens.length === searchTokens.length;
    return doesMatch;
};

var filterEmptyCatalogs = exports.filterEmptyCatalogs = function filterEmptyCatalogs(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.catalog) && x.catalog.catalogId;
    }) : [];
};

var filterEmptyItems = exports.filterEmptyItems = function filterEmptyItems(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.item) && x.item.itemId;
    }) : [];
};

var filterEmptySellers = exports.filterEmptySellers = function filterEmptySellers(list) {
    return list ? list.filter(function (x) {
        return !(0, _isEmpty2.default)(x.seller) && x.seller.sellerId;
    }) : [];
};

var filterCatalogSearch = exports.filterCatalogSearch = function filterCatalogSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return catalogSearchFilter(x, terms);
    }) : list;
};

var filterItemSearch = exports.filterItemSearch = function filterItemSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return itemSearchFilter(x, terms);
    }) : list;
};

var filterSellerSearch = exports.filterSellerSearch = function filterSellerSearch(list, terms) {
    if (!list) {
        return [];
    }
    return terms ? list.filter(function (x) {
        return sellerSearchFilter(x, terms);
    }) : list;
};

// Sorting Functions
var orderByBidderBidTimeAscending = function orderByBidderBidTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidderBidTimestamp']);
};

var orderByBidderBidTimeDescending = function orderByBidderBidTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidderBidTimestamp'], ['desc']);
};

var orderByCatalogSaleStartAscending = function orderByCatalogSaleStartAscending(list) {
    return (0, _orderBy2.default)(list, ['catalog.saleStartTs']);
};

var orderByCatalogSaleStartDescending = function orderByCatalogSaleStartDescending(list) {
    return (0, _orderBy2.default)(list, ['catalog.saleStartTs'], ['desc']);
};

var orderByCatalogTitleAscending = function orderByCatalogTitleAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.catalog.title.toLowerCase();
    }]);
};

// const orderByCatalogTitleDescending = list => {
//     return orderBy(list, [x => x.catalog.title.toLowerCase()], ['desc']);
// };

var orderByItemBidCountAscending = function orderByItemBidCountAscending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidActivityCount']);
};

var orderByItemBidCountDescending = function orderByItemBidCountDescending(list) {
    return (0, _orderBy2.default)(list, ['biddingInfo.bidActivityCount'], ['desc']);
};

// const orderByItemHighBidEstimateAscending = list => {
//     return orderBy(list, ['item.highBidEstimate']);
// };

var orderByItemHighBidEstimateDescending = function orderByItemHighBidEstimateDescending(list) {
    return (0, _orderBy2.default)(list, ['item.highBidEstimate'], ['desc']);
};

var orderByItemLowBidEstimateAscending = function orderByItemLowBidEstimateAscending(list) {
    return (0, _orderBy2.default)(list, ['item.lowBidEstimate']);
};

// const orderByItemLowBidEstimateDescending = list => {
//     return orderBy(list, ['item.lowBidEstimate'], ['desc']);
// };

var orderByItemLotNumberAscending = function orderByItemLotNumberAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.lotNumber.toLowerCase();
    }]);
};

var orderByItemLotNumberDescending = function orderByItemLotNumberDescending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.lotNumber.toLowerCase();
    }], ['desc']);
};

var orderByItemTitleAscending = function orderByItemTitleAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.item.title.toLowerCase();
    }]);
};

// const orderByItemTitleDescending = list => {
//     return orderBy(list, [x => x.item.title.toLowerCase()], ['desc']);
// };

var orderBySellerNameAscending = function orderBySellerNameAscending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.seller.name.toLowerCase();
    }]);
};

var orderBySellerNameDescending = function orderBySellerNameDescending(list) {
    return (0, _orderBy2.default)(list, [function (x) {
        return x.seller.name.toLowerCase();
    }], ['desc']);
};

var getPriceFromCard = exports.getPriceFromCard = function getPriceFromCard(card) {
    if (card.item.isPassed) {
        return 0;
    }
    if (card.item.isSold) {
        return card.item.salePrice;
    }
    return card.biddingInfo.leadingBid || card.item.startPrice || 0;
};

var orderByItemPriceAscending = function orderByItemPriceAscending(list) {
    return (0, _orderBy2.default)(list, [getPriceFromCard]);
};

var orderByItemPriceDescending = function orderByItemPriceDescending(list) {
    return (0, _orderBy2.default)(list, [getPriceFromCard], ['desc']);
};

var orderBySaveSearchItemPublishTimeAscending = function orderBySaveSearchItemPublishTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['savedSearch.publishTs']);
};

var orderBySaveSearchItemPublishTimeDescending = function orderBySaveSearchItemPublishTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['savedSearch.publishTs'], ['desc']);
};

var orderByItemSaveTimeAscending = function orderByItemSaveTimeAscending(list) {
    return (0, _orderBy2.default)(list, ['savedItem.saveTs']);
};

var orderByItemSaveTimeDescending = function orderByItemSaveTimeDescending(list) {
    return (0, _orderBy2.default)(list, ['savedItem.saveTs'], ['desc']);
};

var orderByUpcomingCatalogCountAscending = function orderByUpcomingCatalogCountAscending(list) {
    return (0, _orderBy2.default)(list, ['catalogCounts.upcomingCount']);
};

var orderByUpcomingCatalogCountDescending = function orderByUpcomingCatalogCountDescending(list) {
    return (0, _orderBy2.default)(list, ['catalogCounts.upcomingCount'], ['desc']);
};

var sortCatalogs = exports.sortCatalogs = function sortCatalogs(all, sort) {
    var sorted = void 0;
    if (sort === 'DATE_ASCENDING') {
        sorted = (0, _flow2.default)(orderByCatalogTitleAscending, orderByCatalogSaleStartAscending)(all);
    } else if (sort === 'DATE_DESCENDING') {
        sorted = (0, _flow2.default)(orderByCatalogTitleAscending, orderByCatalogSaleStartDescending)(all);
    } else {
        sorted = all;
    }
    return sorted;
};

var sortItems = exports.sortItems = function sortItems(all, sort) {
    var sorted = void 0;
    if (sort === 'DATE_ASCENDING') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByCatalogSaleStartAscending)(all);
    } else if (sort === 'BID_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByBidderBidTimeAscending)(all);
    } else if (sort === 'BID_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByBidderBidTimeDescending)(all);
    } else if (sort === 'DATE_DESCENDING') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByCatalogSaleStartDescending)(all);
    } else if (sort === 'ESTIMATE_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemHighBidEstimateDescending)(all);
    } else if (sort === 'ESTIMATE_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLowBidEstimateAscending)(all);
    } else if (sort === 'LEAST_BIDS') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemBidCountAscending)(all);
    } else if (sort === 'LOT_NUMBER_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLotNumberAscending)(all);
    } else if (sort === 'LOT_NUMBER_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemLotNumberDescending)(all);
    } else if (sort === 'MOST_BIDS') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemBidCountDescending)(all);
    } else if (sort === 'PRICE_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemPriceDescending)(all);
    } else if (sort === 'PRICE_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemPriceAscending)(all);
    } else if (sort === 'RESULT_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderBySaveSearchItemPublishTimeAscending)(all);
    } else if (sort === 'RESULT_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderBySaveSearchItemPublishTimeDescending)(all);
    } else if (sort === 'SAVED_OLDEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemSaveTimeAscending)(all);
    } else if (sort === 'SAVED_RECENT_FIRST') {
        sorted = (0, _flow2.default)(orderByItemTitleAscending, orderByItemSaveTimeDescending)(all);
    } else if (sort === 'TIME_ENDING_FURTHEST') {
        sorted = (0, _flow2.default)(orderByItemLotNumberDescending, orderByCatalogSaleStartDescending)(all);
    } else if (sort === 'TIME_SOONEST_FIRST') {
        sorted = (0, _flow2.default)(orderByItemLotNumberAscending, orderByCatalogSaleStartAscending)(all);

        var time = Date.now() / 1000;
        var index = -1;
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < sorted.length && index < 0; i++) {
            var current = sorted[i];
            if (current.catalog.saleStartTs > time) {
                index = i;
            }
        }
        sorted = [].concat((0, _toConsumableArray3.default)(sorted.slice(index)), (0, _toConsumableArray3.default)(sorted.slice(0, index)));
    } else {
        sorted = all;
    }
    return sorted;
};

var sortSellers = exports.sortSellers = function sortSellers(all, sort) {
    var sorted = void 0;
    if (sort === 'UPCOMING_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending, orderByUpcomingCatalogCountDescending)(all);
    } else if (sort === 'UPCOMING_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending, orderByUpcomingCatalogCountAscending)(all);
    } else if (sort === 'NAME_HIGHEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameDescending)(all);
    } else if (sort === 'NAME_LOWEST_FIRST') {
        sorted = (0, _flow2.default)(orderBySellerNameAscending)(all);
    } else {
        sorted = all;
    }
    return sorted;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sorting.js
// module id = 8lrs
// module chunks = 46